import { FOCO_SOBRE_AZUL } from 'utils/foco';

import { CartaoDoExtrato, formatarPercentual, formatarPontos } from '../extrato-modelo';
import { coresDaLetra } from './cores';

interface HeroDoTotalProps {
  tituloDoTotal: string;
  rotulo: string;
  total: number;
  unidade: string;
  cartoes: CartaoDoExtrato[];
}

/** Total a creditar e barra de composição com a legenda (PREM-03, PREM-04). */
export default function HeroDoTotal({ tituloDoTotal, rotulo, total, unidade, cartoes }: HeroDoTotalProps) {
  const fatias = cartoes.filter(c => c.letra && typeof c.percentual === 'number');

  return (
    <section
      aria-labelledby="titulo-hero-extrato"
      className="rounded-2xl bg-brand-blue px-5 pb-[26px] pt-7 text-brand-white sm:px-[30px]"
    >
      <div className="mb-[22px] flex flex-wrap items-end justify-between gap-6">
        <div tabIndex={0} className={FOCO_SOBRE_AZUL}>
          {/* SPEC_DEVIATION: rótulo e "(A + B + C + D)" em branco pleno (design 85% e 64%, 3,98 e 2,92:1). */}
          <h2 id="titulo-hero-extrato" className="m-0 mb-0.5 font-text text-[12px] font-normal leading-[normal] text-brand-white">
            {tituloDoTotal} <span>{rotulo}</span>
          </h2>
          <p className="m-0 flex flex-wrap items-baseline gap-2.5">
            <span className="font-display text-[44px] font-extrabold leading-none tracking-[-0.01em] text-brand-yellow sm:text-[64px]">
              {formatarPontos(total)}
            </span>
            <span className="font-display text-[20px] font-bold text-brand-white">{unidade}</span>
          </p>
        </div>
        {/* Sem a frase do crédito no Livelo (AJ2-57): hoje nada diz o que será feito com os pontos. */}
      </div>

      {fatias.length > 0 && (
        <>
          <div aria-hidden="true" className="mb-3.5 flex h-4 w-full overflow-hidden rounded-full bg-white/[0.18]">
            {fatias.map(c => (
              <div key={c.id} className={coresDaLetra(c.letra as string).forte} style={{ width: `${(c.percentual as number).toFixed(2)}%` }} />
            ))}
          </div>
          <ul aria-label="Composição do total" className="m-0 flex list-none flex-wrap gap-x-[22px] gap-y-2.5 p-0 text-[11px]">
            {fatias.map(c => (
              <li key={c.id} tabIndex={0} className={`inline-flex items-center gap-[7px] ${FOCO_SOBRE_AZUL}`}>
                <i aria-hidden="true" className={`inline-block h-[9px] w-[9px] rounded-full ${coresDaLetra(c.letra as string).forte}`} />
                {c.letra} · {c.nomeCurto}
                {/* SPEC_DEVIATION: percentual em branco (design na cor da fatia, 2,62 a 4,44:1); a cor fica no ponto. */}
                <b className="font-bold text-brand-white">{formatarPercentual(c.percentual as number)}</b>
              </li>
            ))}
          </ul>
        </>
      )}
    </section>
  );
}
